import { IStockBalance } from '@/models/stockBalances.model';
import { ROUTES } from '@/models/router.model';
import { formatMoneyWithSeparators } from '@/utils';
import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';
import { Link } from 'react-router-dom';

type TColumnsParams = {
  t: TFunction;
  tProducts: TFunction;
  total?: number;
};

export const getStockBalancesTableColumns = ({ t, tProducts, total }: TColumnsParams): ColumnsType<IStockBalance> => [
  {
    title: `${t('col_product')} (${total ?? 0})`,
    key: 'product',
    width: 220,
    render: (_, record) => (
      <Link to={ROUTES.PRODUCT_DETAILS.replace(':id', record.product.id)}>{record.product.name}</Link>
    ),
  },
  {
    title: t('col_sku'),
    key: 'sku',
    width: 150,
    render: (_, record) => record.product.sku || '—',
  },
  {
    title: t('col_external_id'),
    key: 'external_id',
    width: 170,
    render: (_, record) => record.product.external_id || '—',
  },
  {
    title: t('col_region'),
    dataIndex: ['region', 'name'],
    key: 'region',
    width: 160,
  },
  {
    title: t('col_category'),
    key: 'category',
    width: 240,
    render: (_, record) => record.product.category || '—',
  },
  {
    title: t('col_store'),
    key: 'store',
    width: 180,
    render: (_, record) => record.store?.title ?? '—',
  },
  {
    title: t('col_quantity'),
    dataIndex: 'quantity',
    key: 'quantity',
    width: 130,
  },
  {
    title: t('col_unit'),
    key: 'unit',
    width: 150,
    render: (_, record) =>
      record.product.unit_code ? tProducts(`product_unit_name_${record.product.unit_code}`) : '—',
  },
  {
    title: t('col_price'),
    dataIndex: 'price',
    key: 'price',
    width: 140,
    render: (value: number) => formatMoneyWithSeparators(value),
  },
  {
    title: t('col_discount_price'),
    dataIndex: 'discount_price',
    key: 'discount_price',
    width: 160,
    render: (value: number | null) => formatMoneyWithSeparators(value),
  },
  {
    title: t('col_line_total'),
    dataIndex: 'line_total',
    key: 'line_total',
    width: 140,
    render: (value: number) => formatMoneyWithSeparators(value),
  },
];
